import { action, makeObservable, observable } from "mobx"

import GlobalProjectsCollection from "@src/app/ProjectsCollection"
import { catchErrors, invoicesApi } from "@src/shared/api"
import { InlineObject4, InvoiceResponse } from "@src/shared/api/generated"
import { loading } from "@src/shared/classes/utils/loading"

export type InvoiceFormType = {
  customer_email: string
  customer_name: string
  fiat_price?: string
  invoiceValidityTime?: string
  memo?: string
  project_id: string
  symbol?: string
  unit?: string
}

export class InvoiceEntity extends loading(["fetch", "create"]) {
  state = {} as InvoiceResponse

  constructor(public projects = GlobalProjectsCollection()) {
    super()

    makeObservable(this, {
      create: action.bound,
      fetch: action.bound,
      state: observable.shallow,
    })
  }

  async create(req: InvoiceFormType) {
    const {
      fiat_price: amount,
      invoiceValidityTime,
      symbol,
      unit,
      ...rest
    } = req

    const info: InlineObject4 = {
      ...rest,
      fiat_price: { amount, symbol },
      void_after_seconds:
        req.invoiceValidityTime && req.unit
          ? Number(req.invoiceValidityTime) * Number(req.unit)
          : null,
    }

    return invoicesApi.createInvoice(info).then(({ data: { data } }) => {
      if (data) {
        this.state = { ...data }
      }

      return data
    })
  }

  async fetch(id: string) {
    try {
      const { data: { data } = {} } = await invoicesApi.getInvoice(id)

      if (data) {
        this.state = data
      }
    } catch (e: any) {
      catchErrors(e)
    }
  }
}
